import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';

/**
 * What a brand-new client sees until their first course exists: one call to action and the five
 * steps from an empty account to students enrolled.
 */
function DashboardWelcome() {
  const { t } = useI18n();
  const steps = [
    { n: 1, title: t('dashboard.welcome.cta'), desc: t('dashboard.welcome.step1Desc') },
    { n: 2, title: t('dashboard.welcome.step2Title'), desc: t('dashboard.welcome.step2Desc') },
    { n: 3, title: t('dashboard.welcome.step3Title'), desc: t('dashboard.welcome.step3Desc') },
    { n: 4, title: t('dashboard.welcome.step4Title'), desc: t('dashboard.welcome.step4Desc') },
    { n: 5, title: t('dashboard.welcome.step5Title'), desc: t('dashboard.welcome.step5Desc') },
  ];

  return (
    <div className="dash-welcome">
      <section className="section-card section-card--lg dash-welcome__intro">
        <h2 className="dash-welcome__title">{t('dashboard.welcome.title')}</h2>
        <p className="dash-welcome__sub">{t('dashboard.welcome.subtitle')}</p>
        <Link to="/courses/create" className="ds-btn ds-btn-primary ds-btn-lg">
          <Plus aria-hidden="true" />
          {t('dashboard.welcome.cta')}
        </Link>
      </section>
      <ol className="section-card dash-welcome__steps">
        {steps.map((step) => (
          <li key={step.n} className="ui-list-row dash-step">
            <span className="ui-icon-chip ui-icon-chip--md dash-step__num" data-tone="brand">{step.n}</span>
            <span className="dash-step__text">
              <strong>{step.title}</strong>
              <span>{step.desc}</span>
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default DashboardWelcome;
